module.exports = __webpack_public_path__ + "static/media/home.91964924.png";